module.exports = __webpack_public_path__ + "static/img/Jeremy_Cameron_desktop.2437b94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy_Cameron_desktop.jpg
// module id = q8ju
// module chunks = 0